<template>
  <div v-if="fileReady">
  sdf
    <!-- <vue-viewer :images="file.pageCount">
      <img v-for="src in file.pageCount" :key="src" :src="`${file.link}?page=${page}&width=80`" >
    </vue-viewer> -->
    <!-- <div class="d-flex pd-l-10">
      
      <div :style="`overflow: auto; max-height: calc(95vh - ${minusHeight}px); min-width: 90px`">
        
        <div class="text-muted text-center tx-12 mg-t-5">
          Хуудас: {{ curPage }}/{{ file.pageCount }}
        </div>
        <div v-for="page in file.pageCount" @click="curPage=page" role="button">
          <img :src="`${file.link}?page=${page}&width=80`" class="mg-b-10 bd rounded-5" />
        </div>
      </div>
      <div style="overflow: auto;">
        <img :src="`${file.link}?page=${curPage}&width=1200`" :style="`height: calc(100vh - ${minusHeight}px)`" />
      </div>
      
    </div> -->
    
    <!-- <div
      :id="`pdf_${propFileId}`"
      :style="`height: calc(100vh - ${minusHeight}px)`"
    ></div> -->
  </div>
</template>
<script>
import { fileInheritedDetail } from "@/api/media";
import PDFObject from "pdfobject";

// import 'viewerjs/dist/viewer.css'
// import VueViewer from 'v-viewer'

export default {
  components:{
    // VueViewer
  },
  name: "detail",
  props: {
    propFileId: {
      type: Number,
      default: () => null
    },
    minusHeight: {
      type: Number,
      default: () => 115
    },
    force: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      pageCount: null,
      curPage: 1,
      PDFJS_URL: "https://res.gosmart.mn/static/pdfobject/web/viewer.html",
      fileReady: false,
      file: {},
      deletingFileId: 0
    };
  },

  mounted() {
    this.configure();
  },
  methods: {
    configure() {
      if (
        this.$store.state.app.activeGroup.PDFJS_URL != undefined &&
        this.$store.state.app.activeGroup.PDFJS_URL != ""
      ) {
        this.PDFJS_URL = this.$store.state.app.activeGroup.PDFJS_URL;
      }

      this.init();
    },
    init() {
      let self = this;
      let _id = this.propFileId;
      if (_id == undefined) {
        _id = this.$route.params.id;
      }

      fileInheritedDetail({ params: { id: _id }, store: this.$store }).then(
        res => {
          if (res != false) {
            //console.log('res fileInheritedDetail ', res);
            this.file = res.data.file;
            this.fileReady = true;

            var options = {
              pdfOpenParams: {
                pagemode: this.$store.state.app.isMobile ? "" : "thumbs",
                navpanes: 0,
                toolbar: 0,
                statusbar: 0,
                view: "FitH"
              },
              page: 1,
              forcePDFJS: true,
              PDFJS_URL: self.PDFJS_URL
            };
            //console.log(this.file.link);
            this.$nextTick(() => {
              PDFObject.embed(
                this.file.link,
                `#pdf_${this.propFileId}`,
                options
              );
            });
          }
        }
      );
    }
  }
};
</script>
